import {
	Center,
	createStyles,
	Divider,
	Group,
	Skeleton,
	Stack,
} from '@mantine/core';
import type { EmptyStateButtons } from '@repo/common/components/NewEmptyState/EmptyState';
import { EmptyState } from '@repo/common/components/NewEmptyState/EmptyState';
import { observer } from 'mobx-react-lite';
import LoadingTable from '../../../../../components/LoadingTable';
import policyIssueDrawerStore from '../store';
import { PolicyIssueEntityContent } from './EntityContent';
import { PolicyIssueIssueContent } from './IssueContent';

const useStyles = createStyles(() => ({
	content: {
		width: '100%',
		height: 'fit-content',
		flexDirection: 'column',
		flexFlow: 'nowrap',
		alignItems: 'flex-start',
		gap: 0,
	},
}));

interface PolicyIssueDrawerContentProps {
	handleAcknowledgeOnClick: (resultId: string) => void;
	handleResolveOnClick: (resultId: string) => void;
	handleIgnoreOnClick: (resultId: string) => void;
	handleReopenOnClick: (resultId: string) => void;
	readOnly?: boolean;
}

export const PolicyIssueDrawerContent = observer(
	({
		handleAcknowledgeOnClick,
		handleResolveOnClick,
		handleIgnoreOnClick,
		handleReopenOnClick,
		readOnly = false,
	}: PolicyIssueDrawerContentProps) => {
		const { classes } = useStyles();

		if (policyIssueDrawerStore.loading) {
			return (
				<Stack spacing="xl" w="100%" p="md">
					<Skeleton height={40} width="70%" radius="xs" />
					<LoadingTable />
				</Stack>
			);
		}

		if (
			policyIssueDrawerStore.isError ||
			policyIssueDrawerStore.entity === undefined
		) {
			const buttons: EmptyStateButtons = [
				{
					variant: 'default',
					label: 'Go back',
					onClick: policyIssueDrawerStore.closeEntityDrawer,
				},
			];

			return (
				<Center w="100%">
					<EmptyState
						iconName="lock"
						body="You are not authorized to view this resource or it does not exist. Contact your workspace admin to get access. If you think this is a mistake contact customer support"
						buttons={buttons}
					/>
				</Center>
			);
		}

		return (
			<Group className={classes.content} spacing={0}>
				<PolicyIssueEntityContent />
				<Divider orientation="vertical" />
				<PolicyIssueIssueContent
					handleAcknowledgeOnClick={handleAcknowledgeOnClick}
					handleResolveOnClick={handleResolveOnClick}
					handleIgnoreOnClick={handleIgnoreOnClick}
					handleReopenOnClick={handleReopenOnClick}
					readOnly={readOnly}
				/>
			</Group>
		);
	}
);
